import * as React from 'react';
import { Button } from '../../../components/ui/Button';
import { Modal, ModalBody, ModalFooter } from 'reactstrap';

interface Props {
  dismissDeleteUserModal: () => void
  inactivateUser: (userId: number) => void
  selectedUser: IManagedUser
  isOpen: boolean
}

export const DeleteConfirmationModal = (props: Props) => {
  const { selectedUser, isOpen, dismissDeleteUserModal, inactivateUser } = props
  if (selectedUser) {
    if (selectedUser.hasAssignedActionAlerts) { // this means it cannot be inactivated
      return (
        <Modal wrapClassName="blacklight" isOpen={isOpen} modalClassName="blacklight-modal">
          <ModalBody>
            <h4 id="userDeleteMessageHeader">Are you sure?</h4>
            <span id="userDeleteMessage">Unable to Inactivate User Due to Unresolved Action Alerts Assigned to: <b style={{ color: 'red' }}>{selectedUser.username}</b></span>
          </ModalBody>
          <ModalFooter>
            <Button className="btn btn-white" onClick={() => dismissDeleteUserModal()}>Cancel</Button>
          </ModalFooter>
        </Modal>
      );
    } else {
      return (
        <Modal wrapClassName="blacklight" isOpen={isOpen} modalClassName="blacklight-modal">
          <ModalBody>
            <h4 id="userDeleteMessageHeader">Are you sure?</h4>
            <span id="userDeleteMessage">Are you sure you want to inactivate user: <b style={{ color: 'red' }}>{selectedUser.username}</b></span>
          </ModalBody>
          <ModalFooter>
            <Button className="btn btn-action" onClick={() => inactivateUser(selectedUser.id)}>Inactivate</Button>
            <Button className="btn btn-white" onClick={() => dismissDeleteUserModal()}>Cancel</Button>
          </ModalFooter>
        </Modal>
      )
    }
  } else return null
};
